export default "__VITE_ASSET__AKmUwXgJ__"